import ApiService from "@/services/api/ApiService";
import {GeoJSON} from "leaflet";

/**
 * Service to handle requests about geojson files
 */
const geoJsonService = {
  async getGeoJsonFiles(): Promise<string[]> {
    return ApiService.get<string[]>("/geojson");
  },
  async getGeoJsonFile(name: string): Promise<GeoJSON.GeoJsonObject> {
    return ApiService.get<GeoJSON.GeoJsonObject>(`/geojson/${name}`);
  },
};

export default geoJsonService;